import React from "react";

export function StatCounter() {
  const injectSC = () => {
    var script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.text = `
    var sc_project = 12466102;
    var sc_invisible = 1;
    var sc_security = "2a997199";`;
    document.body.appendChild(script1);
    var script2 = document.createElement("script");

    script2.src = "https://www.statcounter.com/counter/counter.js";
    script2.async = true;

    document.body.appendChild(script2);
  };
  return <>{process.env.NODE_ENV !== "development" ? injectSC() : ""}</>;
}
